export default __webpack_public_path__ + "static/media/DevaidLogo.6066b757.png";